import './EggLanding.scss';
import React from 'react';
import { GenericCard } from '../Card/GenericCard';
import { Instruction } from '../Instruction/Instruction';
import { Link } from 'react-router-dom';
import instructionOne from '../../assets/img/egg/instructions/how_to_1.jpg';
import instructionTwo from '../../assets/img/egg/instructions/how_to_2.jpg';
import instructionThree from '../../assets/img/egg/instructions/how_to_3.jpg';
import instructionFour from '../../assets/img/egg/instructions/how_to_4.jpg';
import { OmnigrowTooltip } from './OmnigrowTooltip';
import { PlayToMintPlatformDisclaimer } from '../PlayToMint/PlayToMint';
import { useEggCountdownContext } from '../../contexts/EggStageContext';
import { Countdown } from '../Countdown/Countdown';
import { routes } from '../../routing/routes';
import { PlatformButton } from '../Button/PlatformButton';
import { Egg } from './Egg';

const instructions = [
  {
    image: instructionOne,
    title: 'Play Twilight Shift',
    description: (
      <>
        Download, install, and play the Twilight Shift game <Link to={routes.launcher()}>here</Link>
      </>
    ),
  },
  {
    image: instructionTwo,
    title: 'Visit Adrian’s Sanctuary',
    description: (
      <>
        Go to <Link to={routes.stories()}>Story</Link> and learn the breakthroughs that Adrian has
        discovered with Gribble Eggs
      </>
    ),
  },
  {
    image: instructionThree,
    title: 'Incubate and Pair your Eggs',
    description: (
      <>
        Use your <Link to={routes.dashboard()}>incubator</Link> to level up your eggs. Pair your
        Breakers with your Eggs for extra bonuses
      </>
    ),
  },
  {
    image: instructionFour,
    title: 'Complete Missions',
    description: (
      <>
        Go to <Link to={routes.missions()}> Missions</Link> to explore the world of the DuskBreakers
      </>
    ),
  },
];

function CountdownWrapper() {
  const context = useEggCountdownContext();
  const { title } = context.stage;

  const label =
    context.type === 'countdown' ? `${title} • NEXT STAGE IN:` : `${title} • FINAL STAGE`;

  return (
    <>
      <p className="egg-countdown-label">{label}</p>
      {context.type === 'countdown' && <Countdown countdown={context.countdown} />}
    </>
  );
}

export function EggLanding() {
  return (
    <Egg>
      <div className="egg-home-incubator-wrapper">
        <div className="egg-home-landing-wrapper">
          <div className="egg-home-landing-left egg-home-landing-section">
            <h1 className="egg-home-landing-title">The Gribble Eggsperience</h1>
            <p className="egg-home-description">
              Incubate your Gribble Eggs and level them up to hatch the strongest Gribble possible.
              Level up your Eggs by collecting OmniGrow, a miracle substance made of Duskite
              materials.
            </p>
            <div className="egg-home-landing-right egg-home-landing-section egg-home-countdown-mobile">
              <CountdownWrapper />
            </div>
            <div className="stacked-aligned-buttons">
              <PlatformButton
                platform="windows"
                text="Play Twilight Shift"
                link={routes.launcher()}
              />
              <PlatformButton platform="macos" text="Play Beast Battler" link={routes.game()} />
            </div>
            <PlayToMintPlatformDisclaimer omnigrow />
            <hr />
            <div className="egg-home-title-flex">
              <h2 className="egg-home-landing-title-small">How to Collect OmniGrow</h2>
              <OmnigrowTooltip />
            </div>
            <div className="egg-home-instructions">
              {instructions.map((instruction, number) => (
                <GenericCard
                  key={number}
                  className="egg-home-instruction-card"
                  imageUrl={instruction.image}
                  top={
                    <Instruction
                      number={number + 1}
                      title={instruction.title}
                      description={instruction.description}
                    />
                  }
                />
              ))}
            </div>
          </div>
          <div className="egg-home-landing-right egg-home-landing-section egg-home-countdown-desktop">
            <CountdownWrapper />
          </div>
        </div>
        <div className="egg-home-incubator-overlay">
          <div className="egg-home-incubator-overlay-color" />
          <video
            autoPlay
            muted
            src="/egg_assets/incubator_background.mp4"
            className="egg-home-incubator"
          />
        </div>
      </div>
    </Egg>
  );
}
